import { render, staticRenderFns } from "./quickTask.vue?vue&type=template&id=1bd85a21"
import script from "./quickTask.vue?vue&type=script&setup=true&lang=js"
export * from "./quickTask.vue?vue&type=script&setup=true&lang=js"
import style0 from "./quickTask.vue?vue&type=style&index=0&id=1bd85a21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports